import { render } from "./ToolbarUsers.vue?vue&type=template&id=2b4f94ed"
import script from "./ToolbarUsers.vue?vue&type=script&lang=js"
export * from "./ToolbarUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__